import { Table } from 'antd';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { addCommas } from '@zorba-shared/core/Services/textService';
import { isMobile } from '../../../../services/clientService';
import { getTableColumns } from './columns';
import { ZorbaSelect } from '../../../../components/forms';
import { getAllAgents } from '../../../../reducer/User/actions';
import './index.scss';

const tableScroll = {
  scrollToFirstRowOnChange: true,
  x: isMobile() ? true : 'max-content',
};

const BuyerTable = (props) => {
  const { buyers, isLoading, total, currentPage, onUnsubscribeBuyer, onUpdateBuyerAgent, onUpdateSellerAgent, onFilterByBuyerAgent } = props;
  const { agents } = useSelector(({ UserReducer }) => UserReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllAgents()); // Fetch agents on component mount
  }, [dispatch]);

  const updatedBuyers = buyers.map((buyer) => ({
    ...buyer,
    key: buyer._id,
  }));

  const locale = {
    emptyText: isLoading ? null : <p>No Record Found.</p>,
  };

  const onDelete = (item) => {
    props?.onDelete(item);
  };

  const pagination = {
    position: ['bottomRight'],
    onChange: props?.onShowSizeChange,
    total,
    pageSize: 50,
    current: currentPage + 1,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  };

  return (
    <>
      <div className="buyer-table-info">
        <div>{`Total: ${addCommas(total)} buyers`}</div>
        {onFilterByBuyerAgent && (
          <div className="buyer-agent-filter">
            <ZorbaSelect
              options={[{ label: 'All Buyer Agents', value: '' }, ...agents]}
              placeholder="Filter by Buyer Agent"
              onChange={onFilterByBuyerAgent}
              style={{ minWidth: '200px' }}
              allowClear
            />
          </div>
        )}
      </div>
      <Table
        loading={isLoading}
        className="buyer-table"
        columns={getTableColumns(onDelete, onUnsubscribeBuyer, onUpdateBuyerAgent, onUpdateSellerAgent, agents)}
        locale={locale}
        dataSource={updatedBuyers}
        pagination={pagination}
        scroll={tableScroll}
      />
    </>
  );
};

BuyerTable.defaultProps = {
  buyers: [],
  isLoading: false,
};

BuyerTable.propTypes = {
  buyers: PropTypes.arrayOf(PropTypes.shape({})),
  isLoading: PropTypes.bool,
  onFilterByBuyerAgent: PropTypes.func,
};

export default BuyerTable;
